<template>
  <div>
    <Header page="manager_vendor"/>
    <b-container>
      <b-row class="mt-30">
        <b-col cols="12" lg="3" class="text-center">
          <div class="vendor__upload">
            <div class="avatar">
              <div class=" vendor__logo">
                <img :src="vendor.logo" alt class="avt-modal" ref="displayImage" />
              </div>
              <div class="input-upload">
                <label for="uploadfile" class="label-upload"></label>
                <input type="file" id="uploadfile" name="uploadfile" accept=".jpg, .png, .bmp, .gif, .jpeg" class="btn-file input-0"  @change="changeImage($event)"/>
              </div>
            </div>
            <ModalErrorUploadImage @hidePopupImage="hidePopupImage" :avatarError="avatarError"/>
          </div>
        </b-col>
        <b-col cols="12" lg="8">
          <form >
            <div class="form-group">
              <label for="" class="vendor__label">所在地</label>
              <b-row>
                <b-col cols="12" lg="6">
                  <b-row>
                    <b-col cols="5" class="pr-0 input-group">
                      <input type="text" name="" class="input-form" placeholder="100" v-model="zip_code_1" :class="zipCodeHeadFormat()" @input="$v.zip_code_1.$touch()">
                      <small v-if="(!$v.zip_code_1.numeric || !$v.zip_code_1.valid) && ((zip_code_1 !== '') || (zip_code_2 !== ''))" class="text-input error">{{message.ZIPCODE_HEAD_FORMAT}}</small>
                    </b-col>
                    <b-col cols="2" class="d-flex justify-content-center align-content-center"><span class="admin-vendor-spaceIP"></span></b-col>
                    <b-col cols="5" class="pl-0 input-group">
                      <input type="text" name="" class="input-form" placeholder="0001" v-model="zip_code_2" :class="zipCodeTailFormat()" @input="$v.zip_code_2.$touch()">
                      <small v-if="(!$v.zip_code_2.numeric || !$v.zip_code_2.valid) && ((zip_code_2 !== '') || (zip_code_1 !== ''))" class="text-input error">{{message.ZIPCODE_TAIL_FORMAT}}</small>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" lg="6">
                  <input type="text" name="" class="input-form mt-mb-15" placeholder="所在地を入力してください" v-model="vendor.address">
                </b-col>
              </b-row>
            </div>
            <div class="form-group">
              <label for="" class="vendor__label">会社名<span class="required">*</span></label>
              <div class="input-group">
                <input type="text" name="" class="input-form" placeholder="会社名を入力してください" v-model="vendor.company_name" :class="{error: !$v.vendor.company_name.required && invalid}" @input="$v.vendor.company_name.$touch()">
                <small v-if="!$v.vendor.company_name.required && invalid" class="text-input error">{{message.COMPANY_NAME_REQUIRED}}</small>
              </div>
            </div>
            <div class="form-group">
              <label for="" class="vendor__label">事業内容</label>
              <input type="text" name="" id="" class="input-form" placeholder="事業内容を入力してください" v-model="vendor.business_content">
            </div>
            <b-row>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <div class="input-group">
                    <label for="" class="vendor__label">従業員数</label>
                    <input type="text" maxlength="11" id="employee_numberic" name="" class="input-form" placeholder="従業員数を入力してください" v-model="vendor.number_employees" :class="{error: !$v.vendor.number_employees.numeric && invalid}">
                    <small v-if="!$v.vendor.number_employees.numeric && invalid" class="text-input error">{{message.NUMBER_EMPLOYEE_FORMAT}}</small>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <div class="input-group">
                    <label for="" class="vendor__label">資本金</label>
                    <input type="text" maxlength="10" name="" class="input-form" placeholder="資本金を入力してください" v-model="vendor.capital">
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <label for="" class="vendor__label">代表者名<span class="required">*</span></label>
                  <div class="input-group">
                    <input type="text" name="" class="input-form" placeholder="代表者名を入力してください" v-model="vendor.representative_name" :class="{error: !$v.vendor.representative_name.required && invalid}" @input="$v.vendor.representative_name.$touch()">
                    <small v-if="!$v.vendor.representative_name.required && invalid" class="text-input error">{{message.REPRESENTATIVE_NAME_REQUIRED}}</small>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" lg="6">
                <div class="form-group">
                  <label for="" class="vendor__label">代表電話番号<span class="required">*</span></label>
                  <div class="input-group">
                    <input type="text" name="" class="input-form" placeholder="代表電話番号を入力してください" v-model="vendor.representative_phone" :class="phoneError()" @input="$v.vendor.representative_phone.$touch()">
                    <small v-if="!$v.vendor.representative_phone.required && invalid" class="text-input error">{{message.REPRESENTATIVE_PHONE_REQUIRED}}</small>
                    <small v-if="!$v.vendor.representative_phone.valid && invalid && $v.vendor.representative_phone.required" class="text-input error">{{message.PHONE_FORMAT}}</small>
                  </div>
                </div>
              </b-col>
            </b-row>
            <div class="form-group">
              <label for="" class="vendor__label">メールアドレス<span class="required">*</span></label>
              <div class="input-group">
                <input type="text" name="" class="input-form" placeholder="メールアドレスを入力してください" v-model.trim="vendor.representative_email" :class="emailFormat()" @input="$v.vendor.representative_email.$touch()">
                <small v-if="!$v.vendor.representative_email.required && invalid" class="text-input error">{{message.EMAIL_REQUIRED}}</small>
                <small v-if="!$v.vendor.representative_email.valid && invalid && $v.vendor.representative_email.required" class="text-input error">{{message.EMAIL_FORMAT}}</small>
                <small v-if="errorVendorMessage.representative_email" class="text-input error">{{emailError(errorVendorMessage.representative_email[0])}}</small>
              </div>
            </div>
            <div class="form-group">
              <label for="" class="vendor__label">ホームページ</label>
              <input type="text" name="" class="input-form" placeholder="ホームページを入力してください" v-model="vendor.homepage">
            </div>
            <div class="col-12">
              <div class="w-100 mb-30">
                <div class="d-flex mypage__btnGroup justify-content-center btn-reverse">
                  <button class="btn btn-secondary btn-rounder btn-basic mr-30" @click="goBack" type="button">キャンセル</button>
                  <button class="btn btn-primary btn-rounder btn-basic" @click="editVendor" type="button">保存</button>
                </div>
              </div>
            </div>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import {mapState} from 'vuex'
import errorMessage from '../../../utils/errormessage'
import {MESSAGE} from '../../../utils/errorjapanese'
import { numeric, required } from 'vuelidate/lib/validators'
import ModalErrorUploadImage from '@/components/share/ErrorUploadImage'
export default {
  name: 'Add',
  components: {
    Header,
    ModalErrorUploadImage
  },
  data () {
    return {
      avatarError: '',
      message: MESSAGE,
      invalid: false,
      zip_code_1: '',
      zip_code_2: ''
    }
  },
  validations: {
    zip_code_1: {
      numeric,
      valid (zipCode) {
        if (zipCode || this.zip_code_2) {
          const validate = /^[0-9-.+]{3}$/i.test(zipCode)
          return validate
        }
        return true
      }
    },
    zip_code_2: {
      numeric,
      valid (zipCode) {
        if (zipCode || this.zip_code_1) {
          const validate = /^[0-9-.+]{4}$/i.test(zipCode)
          return validate
        }
        return true
      }
    },
    vendor: {
      company_name: {
        required
      },
      representative_name: {
        required
      },
      representative_phone: {
        required,
        valid (phone) {
          const validate = /^[0-9-.+]{3,20}$/i.test(phone)
          return validate
        }
      },
      representative_email: {
        required,
        valid (email) {
          const validate = /^[[a-zA-Z][a-zA-Z0-9_.-]{1,32}@[a-z0-9_-]{2,}(\.[a-z0-9]{2,}){1,}$/.test(email)
          return validate
        }
      },
      number_employees: {
        numeric
      }
    }
  },
  watch: {
    'vendor.representative_email' () {
      this.$store.commit('vendor/CHANGE_ERROR_MESSAGE', '')
    },
    'vendor' () {
      if (this.vendor.zip_code) {
        this.zip_code_1 = this.vendor.zip_code.slice(0, 3)
        this.zip_code_2 = this.vendor.zip_code.slice(3, 7)
      }
    },
    'zip_code_1' (value) {
      this.vendor.zip_code = value + this.zip_code_2
      let postalCode = require('japan-postal-code')
      let me = this
      postalCode.get(me.vendor.zip_code, function (add) {
        me.vendor.address = add.prefecture + add.city + add.area + add.street
      })
    },
    'zip_code_2' (value) {
      this.vendor.zip_code = this.zip_code_1 + value
      let postalCode = require('japan-postal-code')
      let me = this
      postalCode.get(me.vendor.zip_code, function (add) {
        me.vendor.address = add.prefecture + add.city + add.area + add.street
      })
    }
  },
  methods: {
    zipCodeHeadFormat () {
      if (this.zip_code_1 || this.zip_code_2) {
        return ((!this.$v.zip_code_1.valid || !this.$v.zip_code_1.numeric)) ? 'error' : ''
      }
      return ''
    },
    zipCodeTailFormat () {
      if (this.zip_code_1 || this.zip_code_2) {
        return (((!this.$v.zip_code_2.valid || !this.$v.zip_code_2.numeric))) ? 'error' : ''
      }
      return ''
    },
    emailFormat () {
      return ((!this.$v.vendor.representative_email.valid || !this.$v.vendor.representative_email.required) && this.invalid) || this.errorVendorMessage.representative_email ? 'error' : ''
    },
    phoneError () {
      return (!this.$v.vendor.representative_phone.required || !this.$v.vendor.representative_phone.valid) && this.invalid ? 'error' : ''
    },
    goBack () {
      this.$store.commit('vendor/CHANGE_ERROR_MESSAGE', '')
      this.$router.push('/manager/company')
    },
    editVendor (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      const formData = new FormData()
      if (this.imageVendor !== this.vendor.logo) {
        formData.append('logo', this.vendor.logo)
      }
      if (this.vendor.zip_code) {
        formData.append('zip_code', this.vendor.zip_code)
      }
      if (this.vendor.address) {
        formData.append('address', this.vendor.address)
      }
      if (this.vendor.business_content) {
        formData.append('business_content', this.vendor.business_content)
      }
      if (this.vendor.capital) {
        formData.append('capital', this.vendor.capital)
      }
      formData.append('company_name', this.vendor.company_name)
      if (this.vendor.number_employees) {
        formData.append('number_employees', this.vendor.number_employees)
      }
      formData.append('representative_email', this.vendor.representative_email)
      formData.append('representative_name', this.vendor.representative_name)
      if (this.vendor.homepage) {
        formData.append('homepage', this.vendor.homepage)
      }
      formData.append('representative_phone', this.vendor.representative_phone)
      formData.append('_method', 'put')
      this.$store.dispatch('vendor/editVendor', formData)
    },
    changeImage (event) {
      if (/\.(jpg|jpeg|png|bmp|gif)$/.test(event.target.files[0].name) && event.target.files[0].size <= 5242880) {
        this.vendor.logo = event.target.files[0]
        let reader = new FileReader()
        reader.addEventListener('load', function () {
          this.$refs.displayImage.src = reader.result
        }.bind(this), false)
        reader.readAsDataURL(this.vendor.logo)
      } else {
        event.target.value = ''
        this.avatarError = MESSAGE.AVATAR_FORMAT
        this.$root.$emit('bv::show::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
      }
    },
    emailError (value) {
      return errorMessage.errorEmail(value)
    },
    hidePopupImage () {
      this.avatarError = ''
      this.$root.$emit('bv::hide::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
    }
  },
  computed: {
    ...mapState({
      vendor: state => state.vendor.vendor,
      imageVendor: state => state.vendor.imageVendor,
      errorVendorMessage: state => state.vendor.errorVendorMessage
    })
  },
  mounted () {
    this.$store.dispatch('vendor/getDetailVendor')
    if (this.vendor.zip_code) {
      this.zip_code_1 = this.vendor.zip_code.slice(0, 3)
      this.zip_code_2 = this.vendor.zip_code.slice(3, 7)
    }
    window.scrollTo({
      top: 0
    })
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/vendor/detail_vendor.scss";
@import '@/assets/stylesheet/admin/vendor.scss';
</style>



// WEBPACK FOOTER //
// src/views/Manager/Company/Edit.vue